import { useCallback } from 'react';
import { IntlProvider, useIntl } from 'react-intl';
import type { ReactNode } from 'react';
import { messages, type Locale } from './messages';

export function I18nProvider({ locale, children }: { locale: Locale; children: ReactNode }) {
  return (
    <IntlProvider locale={locale} messages={messages[locale]} defaultLocale="lt">
      {children}
    </IntlProvider>
  );
}

export type Translate = (key: string, values?: Record<string, string | number | Date>) => string;

/** `t('greetingMorning', { name })`: a message from the ARB files, by its key. */
export function useT(): Translate {
  const intl = useIntl();
  return useCallback((key, values) => intl.formatMessage({ id: key }, values), [intl]);
}

export function useLocale(): Locale {
  return useIntl().locale as Locale;
}
